module.exports = __webpack_public_path__ + "static/img/ban-7-1.07e7db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-7-1.png
// module id = KEWe
// module chunks = 0